// extracted by mini-css-extract-plugin
export default {"imagesStack":"_1cw0iul","icon":"_1l6o598","img":"_1ku3xa8"};